import * as Models from "..";
import { IInvoiceSubmissionModel, InvoiceDetails, InvoiceSubmissionModel } from "../ProcessReview/invoiceSubmission";

export interface IMilestoneInvoiceSubmissionModel extends IInvoiceSubmissionModel {
  ptoDate: Date;
  ptoLetter: Models.DocumentManagement.CustomerDocumentUploadModel.CustomerDocumentUploadModel;
}

export class MilestoneInvoiceSubmissionModel extends InvoiceSubmissionModel implements IMilestoneInvoiceSubmissionModel {
  public invoiceNumber: string;
  public document = new Models.DocumentManagement.CustomerDocumentUploadModel.CustomerDocumentUploadModel();
  public igsCustomerNumber: string;
  public ptoDate: Date;
  public ptoLetter = new Models.DocumentManagement.CustomerDocumentUploadModel.CustomerDocumentUploadModel();
}

export class MilestoneDetails extends InvoiceDetails {
  public eventGroupName: string;
  public milestoneCode: string;
  public proposedPtoDate: Date;
}
